import api from '@/utils/api';

/**
 * delete user
 *
 * @param {string} userId - The user id
 * @returns {Promise} The promise object of the api call
 */
const deleteUserApi = (userId) => api.delete(`user/${userId}`);

export default deleteUserApi;
